<template>
  <v-app>
    <AppWrapperView>
      <v-main>
        <v-container class="pa-8" fluid>
          <v-form @submit.prevent="search">
            <v-row>
              <v-col cols="12" class="text-right">
                <v-btn
                  theme="dark"
                  class="ml-4 px-8 bg-grey-darken-3"
                  elevation="2"
                  type="submit"
                  >{{ $t('common.action.search') }}</v-btn
                >
              </v-col>
            </v-row>
            <v-row>
              <v-col cols="12" class="text-body-2 text-grey-darken-1">
                {{ $t('tanaoroshiWarehouseTransfer.label.description') }}
              </v-col>
            </v-row>
          </v-form>
        </v-container>
        <div class="table_wrap resizable-table">
          <table>
            <thead>
              <tr>
                <th v-for="header in headers" :key="header">
                  <div class="header-title">
                    {{ $t("tanaoroshiWarehouseTransfer.label.table." + header) }}
                  </div>
                  <div class="resize-handle" @mousedown="resizeColumnWidth"></div>
                </th>
              </tr>
            </thead>
            <tbody v-for="tana in displayTable" :key="tana.tanaoroshiId">
              <tr v-for="(move, idx) in tana.moveCountList" :key="move.moveType">
                <template v-if="idx === 0">
                  <td>{{ tana.num }}</td>
                  <td>{{ tana.startDatetime }}</td>
                  <td>{{ tana.endDatetime }}</td>
                  <td>{{ tana.statusLabel }}</td>
                  <td>{{ tana.inventoryModeLabel }}</td>
                </template>
                <template v-else>
                  <td></td>
                  <td></td>
                  <td></td>
                  <td></td>
                  <td></td>
                </template>
                <td>
                  <a style="color: #1976d2; cursor: pointer;" @click="moveDetail(tana, move.moveType)">
                    {{ $t('tanaoroshiWarehouseTransfer.moveType.' + move.moveType) }}
                  </a>
                </td>
                <td>{{ move.moveCount }}</td>
                <td>{{ idx === 0 ? tana.kakuteisyaCode : "" }}</td>
                <td width="4em">
                  <v-btn
                    v-if="idx === 0"
                    size="small"
                    class="bg-indigo-darken-1"
                    elevation="2"
                    @click="moveDetail(tana, ALL_MOVE_TYPE)"
                    >{{ $t('tanaoroshiWarehouseTransfer.action.detail') }}</v-btn
                  >
                </td>
              </tr>
            </tbody>
          </table>
        </div>
        <ZeroData v-if="zeroDataWarningDialogFlg" :handle-ok="closeZeroDataDialog" />
      </v-main>
    </AppWrapperView>
  </v-app>
</template>

<script lang="js">
import AppWrapperView from "@/components/views/AppWrapperView";
import api from "@/apis/staff";
import utils from "@/utils";
import router from "@/router/index";
import Paths from "@/router/indexPaths";
import ZeroData from "@/components/dialog/ZeroDataDialog";
import tableUtils from "@/utils/tableUtils";

// 全体を表す移動種別
const ALL_MOVE_TYPE = 0;

/**
 * 棚卸倉庫移動履歴
 * 本社の棚卸確定時に移動した資産（自動倉庫・店間・手修正（棚卸調整）・手修正（在庫移動））の件数を、
 * 確定済みの棚卸ごと・移動種別ごとに表示する。
 * （JCIKAIHATSU-339 資産管理 #23・#24）
 */
export default {
  components: { AppWrapperView, ZeroData },
  computed: {
    // 日付を表示用に変換したデータ
    displayTable() {
      return this.tanaoroshiList.map((x) => ({
        ...x,
        startDatetime: utils.putSplitWordToCalendarWithTime(x.startDatetime),
        endDatetime: utils.putSplitWordToCalendarWithTime(x.endDatetime),
      }));
    },
    // ヘッダー
    headers() {
      return this.$getTableDef("TanaoroshiWarehouseTransferPage");
    },
  },

  data() {
    return {
      ALL_MOVE_TYPE,
      tanaoroshiList: [],
      // 0件取得時の警告ダイアログ
      zeroDataWarningDialogFlg: false,
    };
  },
  methods: {
    // 明細画面へ
    moveDetail(tanaoroshi, moveType) {
      router.push({
        name: Paths.TANAOROSHI_WAREHOUSE_TRANSFER_DETAIL,
        query: { tanaoroshiId: tanaoroshi.tanaoroshiId, moveType: moveType },
      });
    },

    closeZeroDataDialog() {
      this.zeroDataWarningDialogFlg = false;
    },

    // 検索
    search() {
      api.post("/tanaoroshi/warehouse-transfer/search", {})
        .then((response) => {
          const results = response.data.results;
          this.tanaoroshiList = results?.tanaoroshiList ?? [];

          // 0件ダイアログ処理
          if (this.tanaoroshiList.length == 0) this.zeroDataWarningDialogFlg = true;
          this.$nextTick(() => tableUtils.adjustColumnWidth(tableUtils.getSearchResultTable()));
        })
        .catch(() => {
          this.tanaoroshiList = [];
          this.zeroDataWarningDialogFlg = true;
        });
    },
    resizeColumnWidth: tableUtils.resizeColumnWidth,
  },

  mounted() {
    // 検索条件が無いため、表示と同時に検索する
    this.search();
  },
};
</script>

<style lang="scss" scoped>
.table_wrap {
  overflow: auto;
  margin: 30px;
  table {
    white-space: nowrap;
    border: solid 1px #bdbdbd;
    width: 100%;
    min-width: 900px;
    border-radius: 10px;
    border-collapse: collapse;
    text-align: center;
    tr {
      &:not(:last-child) {
        border-bottom: 1px solid #eeeeee;
      }
    }
    tbody {
      &:not(:last-child) {
        border-bottom: 1px solid #eeeeee;
      }
    }
    th {
      padding: 10px;
      background-color: #3949ab;
      color: #fff;
    }
  }
  td {
    padding: 6px 3px;
  }
}
</style>
